package frontend.pages

import androidx.compose.runtime.Composable
import components.*
import frontend.App
import frontend.lib.classList
import frontend.models.User
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text

@Composable
fun ProfileUI(app: App, user: User) {
    RoundedContainer {
        H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
            Text("Profile settings")
        }

        Div(attrs = { classList("border-t border-gray-200 px-4 py-5 sm:p-0") }) {
            Dl(attrs = { classList("sm:divide-y sm:divide-gray-200") }) {
                Div(attrs = { classList("py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6") }) {
                    Dt(attrs = { classList("sm:divide-y sm:divide-gray-200") }) {
                        Text("Login")
                    }
                    Dd(attrs = { classList("sm:divide-y sm:divide-gray-200") }) {
                        Text(user.userAccount.loginName)
                    }
                }
                Div(attrs = { classList("py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6") }) {
                    Dt(attrs = { classList("sm:divide-y sm:divide-gray-200") }) {
                        Text("(DEV) Check account balance to create order")
                    }
                    Dd(attrs = { classList("sm:divide-y sm:divide-gray-200") }) {
                        TCheckbox("checkBalance", app.checkBalance) {
                            onChange { app.checkBalance = !app.checkBalance }
                        }
                    }
                }
            }
        }
    }
}